import { buildQuerySummary } from './headless-query-summary.js';
export * from './headless-query-summary.js';
/**
 * Defines a `QuerySummary` controller instance.
 * @group Definers
 *
 * @returns The `QuerySummary` controller definition.
 * */
export function defineQuerySummary() {
    return {
        build: (engine) => buildQuerySummary(engine),
    };
}
